<asw-plan-review-pres
  [fareConditionsResponse]="fareConditionsResponse"
  [isAwardBooking]="isAwardBooking"
></asw-plan-review-pres>
